import api from './axios';

const paymentApi = {
  getSettings: async (clientId) => {
    const response = await api.get(`/clients/${clientId}/payment-settings`);
    return response.data;
  },
  updateSettings: async (clientId, payload) => {
    const response = await api.put(`/clients/${clientId}/payment-settings`, payload);
    return response.data;
  },
};

export default paymentApi;
